import { __assign, __rest } from "tslib";
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
/** this custom input for make that tags area can be scrollable */
export var RcDownshiftInput = function (_a) {
    var inputRef = _a.inputRef, containerRef = _a.containerRef, startAdornment = _a.startAdornment, containerClassName = _a.containerClassName, onContainerClick = _a.onContainerClick, rest = __rest(_a, ["inputRef", "containerRef", "startAdornment", "containerClassName", "onContainerClick"]);
    return (React.createElement("div", { ref: containerRef, onClick: onContainerClick, className: containerClassName },
        startAdornment,
        React.createElement("input", __assign({ ref: inputRef }, rest))));
};
